<template>
  <div class="section-parameter" v-if="infos">
    <div class="col-left">
      <h2>{{ $t('settings.personalization.title') }}</h2>
    </div>
    <div class="col-right">
      <div class="form-group">
        <el-checkbox v-model="display">Display</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="customcss">Stylesheet</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="customjs">Javascript</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="customlang">Traduction</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="monster">Monster</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="bubble">Bubble</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="contest">Contest</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="kpiadvice">Coach</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="wave">Wave</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="banner">Banner</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="survey">Survey</el-checkbox>
      </div>
      <div class="form-group">
        <el-checkbox v-model="wheel">Wheels</el-checkbox>
      </div>
      <div class="form-submit">
        <el-button plain @click="save">{{ $t('settings.actions.save') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      infos: null
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    }),
    customcss: {
      get: function () {
        return this.infos.customcss === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.customcss = 1
        } else {
          this.infos.customcss = 0
        }
      }
    },
    display: {
      get: function () {
        return this.infos.status === 'enabled'
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.status = 'enabled'
        } else {
          this.infos.status = 'testing'
        }
      }
    },
    customlang: {
      get: function () {
        return this.infos.customlang === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.customlang = 1
        } else {
          this.infos.customlang = 0
        }
      }
    },
    customjs: {
      get: function () {
        return this.infos.customjs === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.customjs = 1
        } else {
          this.infos.customjs = 0
        }
      }
    },
    monster: {
      get: function () {
        return this.infos.monster === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.monster = 1
        } else {
          this.infos.monster = 0
        }
      }
    },
    bubble: {
      get: function () {
        return this.infos.bubble === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.bubble = 1
        } else {
          this.infos.bubble = 0
        }
      }
    },
    contest: {
      get: function () {
        return this.infos.contest === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.contest = 1
        } else {
          this.infos.contest = 0
        }
      }
    },
    kpiadvice: {
      get: function () {
        return this.infos.kpiadvice === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.kpiadvice = 1
        } else {
          this.infos.kpiadvice = 0
        }
      }
    },
    wave: {
      get: function () {
        return this.infos.wave === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.wave = 1
        } else {
          this.infos.wave = 0
        }
      }
    },
    banner: {
      get: function () {
        return this.infos.banner === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.banner = 1
        } else {
          this.infos.banner = 0
        }
      }
    },
    survey: {
      get: function () {
        return this.infos.survey === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.survey = 1
        } else {
          this.infos.survey = 0
        }
      }
    },
    wheel: {
      get: function () {
        return this.infos.wheel === 1
      },
      set: function (newValue) {
        if (newValue) {
          this.infos.wheel = 1
        } else {
          this.infos.wheel = 0
        }
      }
    }
  },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  methods: {
    ...mapActions('account', ['updateSite', 'updateStatus']),
    init () {
      if (this.site) {
        this.infos = Object.assign({}, {
          id: this.site.id,
          customcss: this.site.customcss,
          customjs: this.site.customjs,
          customlang: this.site.customlang,
          monster: this.site.monster,
          bubble: this.site.bubble,
          contest: this.site.contest,
          kpiadvice: this.site.kpiadvice,
          status: this.site.status,
          wave: this.site.wave,
          banner: this.site.banner,
          survey: this.site.survey,
          wheel: this.site.wheel
        })
      }
    },
    save () {
      // let status = this.infos.status === 1 ? 'enabled' : 'testing'

      // this.updateStatus({site: this.site, status: status}).then(() => {
      this.updateSite(this.infos).then(() => {
        this.$notify({title: 'Success', message: this.$root.$t('notifications.settings.edited'), type: 'success'})
      }).catch((e) => {
        this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/settings_customization.vue